module.exports = __webpack_public_path__ + "img/logo_gricad_horizontal_dark.f7bb877c.png";